var exports = {};

function isHighSurrogate(codePoint) {
  return codePoint >= 55296 && codePoint <= 56319;
}

function isLowSurrogate(codePoint) {
  return codePoint >= 56320 && codePoint <= 57343;
} // Truncate string by size in bytes


exports = function getByteLength(string) {
  if (typeof string !== "string") {
    throw new Error("Input must be string");
  }

  var charLength = string.length;
  var byteLength = 0;
  var codePoint = null;
  var prevCodePoint = null;

  for (var i = 0; i < charLength; i++) {
    codePoint = string.charCodeAt(i); // handle 4-byte non-BMP chars
    // low surrogate

    if (isLowSurrogate(codePoint)) {
      // when parsing previous hi-surrogate, 3 is added to byteLength
      if (prevCodePoint != null && isHighSurrogate(prevCodePoint)) {
        byteLength += 1;
      } else {
        byteLength += 3;
      }
    } else if (codePoint <= 127) {
      byteLength += 1;
    } else if (codePoint >= 128 && codePoint <= 2047) {
      byteLength += 2;
    } else if (codePoint >= 2048 && codePoint <= 65535) {
      byteLength += 3;
    }

    prevCodePoint = codePoint;
  }

  return byteLength;
};

export default exports;